export default "__VITE_ASSET__e9673f18__"